'use client';

import {
  WsRichBedrijf,
  WsRichHuurwoning,
  WsRichKoophuis,
  WsRichParkeren,
  WsRichWoning,
} from '@woonstad/design-system';
import { AanbodNotFoundContent, SITES } from '@woonstad/ui-public-sites';
import { usePathname } from 'next/navigation';
import { type ReactNode } from 'react';

const typeIconMap: Record<string, typeof WsRichHuurwoning> = {
  'sociale-huurwoning': WsRichHuurwoning,
  'bedrijfsruimte': WsRichBedrijf,
  'koopwoning': WsRichKoophuis,
  'parkeerplaats': WsRichParkeren,
  'vrije-sector-huurwoning': WsRichWoning,
  'beleggingspanden': WsRichBedrijf,
  'alle': WsRichHuurwoning,
};

type Props = {
  aanbodPage: ReactNode;
  genericSlot: ReactNode;
};

export function NotFoundRouter({ aanbodPage, genericSlot }: Props) {
  const pathname = usePathname();
  const segments = pathname.split('/').filter(Boolean);
  const isAanbodDetailPath = segments[0] === 'aanbod' && segments.length >= 3;

  if (isAanbodDetailPath) {
    return <>{aanbodPage}</>;
  }

  return <>{genericSlot}</>;
}

export function AanbodNotFoundByPath() {
  const pathname = usePathname();
  const segments = pathname.split('/').filter(Boolean);
  const type = segments[1] ?? 'sociale-huurwoning';
  const icon = typeIconMap[type] ?? WsRichHuurwoning;

  return (
    <AanbodNotFoundContent
      site={SITES.Woonstad}
      icon={icon}
      aanbodLink={`/aanbod/${type}`}
      contactLink="/service-contact"
    />
  );
}
